import React, { useEffect, useState } from 'react';
import { NewContentForm } from '../../../components/Content/NewContentForm';
import { SmartContainer, Stack } from '../../../styles/Containers';
import { StyledModal } from '../../../styles/matieralui/Modal';
import { StyledA, StyledB, StyledH3, StyledH5, StyledH6, StyledP } from '../../../styles/StyledHTML';

export const EmptyList = ({ children, model, selector, createAction, buttonText, label, titleLabel = "Title", helper = "Enter a title", args }) => {

    const [open, setOpen] = useState(false);
    const store = selector();

    useEffect(() => {
        if (store.createSuccess) setOpen(false);
    }, [store?.createLoading])
    return (
        <SmartContainer flex align="center" justify="center" width="100%" minHeight="70vh">
            <SmartContainer maxWidth="350px" textAlign="center">

                <StyledH6>Create your first {model}</StyledH6>
                <br />
                <StyledP>Start collaborating with your teams and clients by <StyledB><StyledA onClick={() => setOpen(true)}>creating your first {model}</StyledA></StyledB></StyledP>
            </SmartContainer>
            <StyledModal open={open} onClose={() => setOpen(false)} label={label}>
                <Stack>
                    {!children && (<NewContentForm titleLabel={titleLabel} helper={helper} selector={selector} createAction={createAction} args={args} />)}
                    {children}
                </Stack>
            </StyledModal>
        </SmartContainer>
    )
}